export const homeTitle = "Gebäudereinigung Berlin & Umgebung | M.F.D. & CO";

export const homeDescription =
  "Gebäudereinigung in Berlin und Umgebung: Unterhalt, Glas, Fassade, Bau, Grund- und Teppichreinigung. M.F.D. & CO in Tempelhof – Angebot anfordern.";

export const homeKeywords =
  "Gebäudereinigung Berlin, Gebäudereinigung Berlin Umgebung, Reinigungsfirma Berlin, Büroreinigung Berlin, Gebäudereinigung Tempelhof, Reinigung Potsdam, Reinigung Teltow, Reinigung Schönefeld, Unterhaltsreinigung Berlin, Baureinigung Berlin";

export const berlinDistricts = [
  "Mitte",
  "Friedrichshain-Kreuzberg",
  "Pankow",
  "Charlottenburg-Wilmersdorf",
  "Spandau",
  "Steglitz-Zehlendorf",
  "Tempelhof-Schöneberg",
  "Neukölln",
  "Treptow-Köpenick",
  "Marzahn-Hellersdorf",
  "Lichtenberg",
  "Reinickendorf",
];

export const surroundingTowns = [
  "Potsdam",
  "Teltow",
  "Kleinmachnow",
  "Stahnsdorf",
  "Großbeeren",
  "Ludwigsfelde",
  "Blankenfelde-Mahlow",
  "Schönefeld",
  "Königs Wusterhausen",
  "Bernau bei Berlin",
  "Oranienburg",
  "Hennigsdorf",
  "Falkensee",
  "Strausberg",
  "Erkner",
];

const berlin = {
  "@type": "City",
  name: "Berlin",
  sameAs: "https://www.wikidata.org/wiki/Q64",
};

export const areaServed = [
  berlin,
  ...berlinDistricts.map((name) => ({
    "@type": "AdministrativeArea",
    name,
    containedInPlace: { "@type": "City", name: "Berlin" },
  })),
  ...surroundingTowns.map((name) => ({
    "@type": "City",
    name,
    containedInPlace: { "@type": "State", name: "Brandenburg" },
  })),
];
